export enum SourceType {
  website = 'website',
  newsPaper = 'newspapers',
  book = 'book',
  journal = 'journal'
}
